import { render, staticRenderFns } from "./OtherPage.vue?vue&type=template&id=1394b7a3&scoped=true"
import script from "./OtherPage.vue?vue&type=script&lang=js"
export * from "./OtherPage.vue?vue&type=script&lang=js"
import style0 from "./OtherPage.vue?vue&type=style&index=0&id=1394b7a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394b7a3",
  null
  
)

export default component.exports